import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ authUser, children }) {
  const location = useLocation();

  if (!authUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

export default ProtectedRoute;
